document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-recovery-stack').forEach(function (widget) {
    var options = widget.querySelectorAll('.pdp-recovery-stack__option');
    var priceTargetSelector = widget.dataset.priceTarget;
    var formId = widget.dataset.formId;
    var form = document.getElementById(formId);
    var selected = 'main';

    var mainPriceFormatted = widget.dataset.mainPriceFormatted;
    var stackPriceFormatted = widget.dataset.stackPriceFormatted;
    var stackVariantId = widget.dataset.stackVariantId;
    var mainAvailable = widget.dataset.mainAvailable === 'true';
    var stackAvailable = widget.dataset.stackAvailable === 'true';

    var submitBtn = form
      ? form.querySelector('button[type="submit"][name="add"]')
      : null;
    var submitBtnTextEl = submitBtn ? submitBtn.querySelector('span') : null;
    var dynamicCheckoutWrapper = form
      ? form.querySelector('[data-shopify="payment-button"]')
      : null;

    function getQuantity() {
      var input = document.querySelector('.quantity__input[form="' + formId + '"]');
      var val = input ? parseInt(input.value, 10) : 1;
      return (!val || val < 1) ? 1 : val;
    }

    function updatePriceDisplay() {
      var priceTarget = document.querySelector(priceTargetSelector);
      if (!priceTarget) return;
      var priceEl = priceTarget.querySelector('.price-item--regular, .price-item');
      var displayPrice = selected === 'stack' ? stackPriceFormatted : mainPriceFormatted;
      if (priceEl) {
        priceEl.textContent = displayPrice;
      }
    }

    function updateAvailabilityDisplay() {
      var isAvailable = selected === 'stack' ? stackAvailable : mainAvailable;

      if (submitBtn) {
        submitBtn.disabled = !isAvailable;
        submitBtn.classList.toggle('disabled', !isAvailable);
      }
      if (submitBtnTextEl) {
        submitBtnTextEl.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }

      if (dynamicCheckoutWrapper) {
        dynamicCheckoutWrapper.style.display = selected === 'stack' ? 'none' : '';
      }
    }

    function updateCartQuantityLabel() {
      var variantId = selected === 'stack' ? stackVariantId : widget.dataset.mainVariantId;

      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var qtyInCart = 0;
          cart.items.forEach(function (item) {
            if (String(item.variant_id) === String(variantId)) {
              qtyInCart += item.quantity;
            }
          });

          var rulesCartEl = document.querySelector('.quantity__rules-cart');
          var cartQtySpan = document.querySelector('.quantity-cart');

          if (cartQtySpan) {
            cartQtySpan.textContent = qtyInCart;
          }
          if (rulesCartEl) {
            rulesCartEl.classList.toggle('hidden', qtyInCart === 0);
          }
        })
        .catch(function (err) {
          console.error('[recovery-stack] updateCartQuantityLabel error:', err);
        });
    }

    function setSelected(option) {
      selected = option;
      options.forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.option === option);
      });
      updatePriceDisplay();
      updateAvailabilityDisplay();
      updateCartQuantityLabel();
    }

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSelected(btn.dataset.option);
      });
    });

    updateAvailabilityDisplay();

    function refreshCartUI() {
      console.log('[recovery-stack] refreshCartUI called');

      var cartDrawer = document.querySelector('cart-drawer');
      console.log('[recovery-stack] cartDrawer element found:', cartDrawer);

      fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (res) {
          console.log('[recovery-stack] section fetch status:', res.status);
          return res.json();
        })
        .then(function (sections) {
          console.log('[recovery-stack] section fetch data:', sections);

          if (cartDrawer && sections['cart-drawer']) {
            var parser = new DOMParser();
            var newDrawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = newDrawerDoc.querySelector('cart-drawer');
            console.log('[recovery-stack] parsed newDrawer:', newDrawer);

            if (newDrawer) {
              cartDrawer.replaceWith(newDrawer);
              cartDrawer = newDrawer;
              console.log('[recovery-stack] cartDrawer replaced');
            }
          }

          var cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble && sections['cart-icon-bubble']) {
            cartIconBubble.innerHTML = sections['cart-icon-bubble'];
            console.log('[recovery-stack] cart icon bubble updated');
          }

          if (cartDrawer) {
            console.log('[recovery-stack] cartDrawer.open is a function:', typeof cartDrawer.open === 'function');
            cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
              console.log('[recovery-stack] cartDrawer.open() called');
            } else {
              console.warn('[recovery-stack] cartDrawer.open is not a function, cannot auto-open');
            }
          }
        })
        .catch(function (err) {
          console.error('[recovery-stack] refreshCartUI error:', err);
        });
    }

    function addStackToCart() {
      if (!stackAvailable) return;

      var qty = getQuantity();
      if (submitBtn) submitBtn.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: stackVariantId, quantity: qty }]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function (data) {
          console.log('[recovery-stack] add.js success:', data);
          refreshCartUI();
          updateCartQuantityLabel();
        })
        .catch(function (err) {
          console.error('[recovery-stack] addStackToCart error:', err);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = !stackAvailable;
        });
    }

    if (submitBtn) {
      submitBtn.addEventListener(
        'click',
        function (e) {
          if (selected !== 'stack') return; // let native Moisturiser add-to-cart proceed as normal

          e.preventDefault();
          e.stopImmediatePropagation();
          addStackToCart();
        },
        { capture: true }
      );
    }
  });
});